import { render, staticRenderFns } from "./text-field-validador.vue?vue&type=template&id=1dc4fce8"
import script from "./text-field-validador.vue?vue&type=script&lang=js"
export * from "./text-field-validador.vue?vue&type=script&lang=js"
import style0 from "./text-field-validador.vue?vue&type=style&index=0&id=1dc4fce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports